<template>
  <div class="container pb-16">
    <navigation-drawer :titles="title"/>
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="mr-2 mb-2  font16px">نقش</div>
        <v-autocomplete
            class="input-border"
            v-model="TypeRole"
            :items="$roles"
            item-text="name"
            item-value="id"
            dense
            hide-details
            solo
            height="38"
            label="اجباری"
        ></v-autocomplete>
        <div class="mr-2 mb-2 font16px mt-5">دسترسی به دسته بندی تیکت ها</div>
        <v-autocomplete
            class="input-border"
            chips
            small-chips
            multiple
            deletable-chips
            v-model="typeTickets"
            :items="typeTicketsItems"
            item-text="Name"
            item-value="TicketCategoryId"
            hide-details
            solo
        ></v-autocomplete>
        <div class="mr-2 mb-2  font16px mt-5"> نام کاربری</div>
        <v-text-field
            class="input-border"
            v-model="UserName"
            solo
            dense
            hide-details
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">نام</div>
        <v-text-field
            class="input-border"
            v-model="Name"
            solo
            dense
            hide-details
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">نام خانوادگی</div>
        <v-text-field
            class="input-border"
            v-model="Family"
            solo
            dense
            hide-details
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">رمز عبور</div>
        <v-text-field
            class="input-border"
            v-model="Password"
            :append-icon="value ? 'fa-eye' : 'fa-eye-slash'"
            @click:append="() => (value = !value)"
            :type="value ? 'password' : 'text'"
            :rules="PasswordRules"
            solo
            dense
            label="اجباری"
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">تکرار رمز عبور</div>
        <v-text-field
            class="input-border"
            :rules="repeatPasswordRules.concat(passwordConfirmationRule)"
            v-model="ConfirmPassword"
            :append-icon="value2 ? 'fa-eye' : 'fa-eye-slash'"
            @click:append="() => (value2 = !value2)"
            :type="value2 ? 'password' : 'text'"
            solo
            dense
            label="اجباری"
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">موبایل</div>
        <v-text-field
            type="number"
            label="اجباری"
            class="input-border"
            v-model="PhoneNumber"
            solo
            dense
            :rules="phoneNumberRules"
        ></v-text-field>
        <div class="mr-2 mb-2  font16px mt-5">ایمیل</div>
        <v-text-field
            :rules="emailRules"
            class="input-border"
            v-model="Email"
            solo
            dense
        ></v-text-field>
        <div class="mr-2 mb-2 font16px mt-5">کد ملی</div>
        <v-text-field
            :rules="nationalCodeRules"
            class="input-border"
            type="number"
            v-model="NationalCode"
            solo
            dense
        ></v-text-field>
        <div class="mt-7 d-flex justify-content-around align-items-center bg-white rounded-lg p-1 align-items-center">
          <div>تایید</div>
          <div>
            <v-checkbox v-model="isActive" color="primary" hide-details class="isActive mt-0"></v-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <v-card>
          <div class="d-flex justify-content-center">
            <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                   name="ImageFileUrl" type="file"
                   @change="attachmentSelected">
            <div v-if="selectedImage !==null">
              <img
                  :src="selectedImage"
                  class="img-fluid p-3" alt="تصویر اصلی"/>
            </div>
            <div v-else class="no-pic-height">عکسی انتخاب نشده است</div>
          </div>
          <div class="p-3 text-center">
            <v-btn
                dark
                elevation="0"
                class="primary rounded-lg"
                @click="$refs.inputUpload.click()">
              انتخاب عکس
            </v-btn>
          </div>
        </v-card>
      </div>
      <div class="col-12 text-center">
        <v-btn v-if="isNew" color="primary" class="rounded-lg" large
               :disabled="Password === null || ConfirmPassword === null || TypeRole === null || PhoneNumber === null "
               @click="defineUser">
          <span class="font16px white--text">انجام</span>
        </v-btn>
        <v-btn v-else color="primary" class="rounded-lg" large
               :disabled="Password === null || ConfirmPassword === null || TypeRole === null || PhoneNumber === null"
               @click="editUser">
          <span class="font16px white--text">ویرایش</span>
        </v-btn>
      </div>
    </div>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import NavigationDrawer from "@/Admin/components/navigationDrawer";

export default {
  name: "setUser",
  components: {NavigationDrawer},
  metaInfo() {
    return {
      title: ' ادمین-' + this.newsTitle
    }
  },
  data: () => ({
    value: String,
    value2: String,
    typeTicketsItems:[],
    typeTickets: null,
    UserName: null,
    newsTitle: null,
    isNew: true,
    showLoaderDialog: false,
    showResultDialog: false,
    dialogResult: null,
    title: null,
    TypeRole: null,
    TypeAdvertisements: null,
    Name: null,
    Family: null,
    Password: '',
    ConfirmPassword: '',
    PhoneNumber: '',
    Email: null,
    NationalCode: '',
    isActive: false,
    selectedImage: null,
    nationalCodeRules: [
      v => (v.length == 10 || v.length == 0) || 'کد ملی 10 رقم است.',
    ],
    repeatPasswordRules: [v => !!v || "ورود تکرار رمز عبور الزامی است"],
    emailRules: [
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(v) || 'ایمیل نامعتبر'
      }
    ],
    phoneNumberRules: [
      value => !!value || "ورود رمز عبور الزامی است",
      value => (value && value[0] === "0") || 'اولین رقم موبایل با عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    PasswordRules: [v => !!v || "ورود رمز عبور الزامی است", v => (v && v.length >= 6) || "طول رمز عبور باید بیشتر از 6 رقم باشد"],
  }),
  computed: {
    passwordConfirmationRule() {
      return () =>
          this.Password === this.ConfirmPassword || "تکرار رمز عبور با رمز عبور یکسان نیست";
    }
  },
  mounted() {
    this.$convertFarsiNumber()
    if (this.$getUserData().token === '') {
      this.$router.replace({path: '/'})
    }
    if (this.$route.query.isNew === 'true') {
      this.title = 'تعریف کاربران'
      this.newsTitle = 'تعریف کاربران'
      this.isNew = true
    } else {
      this.isNew = false
      this.title = 'ویرایش کاربران'
      this.newsTitle = 'ویرایش کاربران'
      this.getData()
    }
    this.getTicketsCategory()
  },
  watch: {
    '$route.query.isNew'() {
      location.reload()
    }
  },
  methods: {
    attachmentSelected(e) {
      let files = e.target.files;
      if (files.length > 0) {
        this.hasPhoto = false;
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.selectedImage = fr.result
          this.selectedImageFilePath = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.selectedImageFilePath = null;
      }
    },
    defineUser() {
      let resStatus = null
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      if (this.Name !== null) {
        formdata.append("Name", this.Name);
      }
      if (this.UserName !== null) {
        formdata.append("UserName", this.UserName);
      }
      if (this.Email !== null) {
        formdata.append("Email", this.Email);
      }
      formdata.append("Password", this.Password);
      formdata.append("ConfirmPassword", this.ConfirmPassword);
      if (this.Family !== null) {
        formdata.append("Family", this.Family);
      }
      if (this.NationalCode !== null) {
        formdata.append("NationalCode", this.NationalCode);
      }
      formdata.append("TypeRole", this.TypeRole);
      if (this.selectedImageFilePath !== null) {
        formdata.append("ImageFileUrl", this.selectedImageFilePath);
      }
      if (this.PhoneNumber !== null) {
        formdata.append("PhoneNumber", this.PhoneNumber);
      }
      formdata.append("IsActive", this.isActive);
      if (this.typeTickets !== null) {
        for (var i = 0; i < this.typeTickets.length; i++) {
          formdata.append("TicketCategoryIds[" + i + "]", this.typeTickets[i]);
        }
        for (const [key, value] of formdata.entries()) {
          console.log(key, value)
        }
      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/DefineUser", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 401) {
              this.showLoaderDialog = false
              this.$router.replace({path: '/'})
            }
            if (resStatus === 200) {
              this.showLoaderDialog = false
              this.$router.push({path: 'listUsers'})
            } else {
              this.showLoaderDialog = false
              this.dialogResult = result
              this.showResultDialog = true
            }
          })
          .catch(error => console.log('error', error));
    },
    editUser() {
      let resStatus = null
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let formdata = new FormData();
      if (this.Name !== null) {
        formdata.append("Name", this.Name);
      }
      if (this.UserName !== null) {
        formdata.append("UserName", this.UserName);
      }
      if (this.Email !== null) {
        formdata.append("Email", this.Email);
      }
      formdata.append("Password", this.Password);
      formdata.append("ConfirmPassword", this.ConfirmPassword);
      if (this.Family !== null) {
        formdata.append("Family", this.Family);
      }
      if (this.NationalCode !== null) {
        formdata.append("NationalCode", this.NationalCode);
      }
      formdata.append("TypeRole", this.TypeRole);
      if (this.hasPhoto) {
        formdata.append("FileUrl", this.selectedImage);
      } else if (this.selectedImageFilePath !== null) {
        formdata.append("ImageFileUrl", this.selectedImageFilePath);
      }
      if (this.PhoneNumber !== null) {
        formdata.append("PhoneNumber", this.PhoneNumber);
      }
      formdata.append("IsActive", this.isActive);
      if (this.typeTickets !== null) {
        for (var i = 0; i < this.typeTickets.length; i++) {
          formdata.append("TicketCategoryIds[" + i + "]", this.typeTickets[i]);
        }
      }
      formdata.append("ID", this.$route.query.id);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditUser", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 401) {
              this.showLoaderDialog = false
              this.$router.replace({path: '/'})
            }
            if (resStatus === 200) {
              this.showLoaderDialog = false
              this.$router.push({path: 'listUsers', query: {role: this.TypeRole}})
            } else {
              this.showLoaderDialog = false
              this.dialogResult = result
              this.showResultDialog = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/EditUser?AppUserID=" + this.$route.query.id, requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            let json = JSON.parse(result)
            this.TypeRole = json.TypeRole
            this.typeTickets = json.TicketCategoryIds
            this.Name = json.Name
            this.UserName = json.UserName
            this.Family = json.Family
            this.Password = json.Password
            this.ConfirmPassword = json.ConfirmPassword
            this.PhoneNumber = json.PhoneNumber
            this.Email = json.Email
            if (json.NationalCode !== null) {
              this.NationalCode = json.NationalCode
            }
            this.isActive = json.IsActive
            this.selectedImage = json.FileUrl
            if (json.FileUrl !== null) {
              this.hasPhoto = true
            }
          })
          .catch(error => console.log('error', error));
    },
    getTicketsCategory(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Admin/TicketCategoriesList", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.typeTicketsItems = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>
